import script from "./SubBubble.vue?vue&type=script&setup=true&lang=js"
export * from "./SubBubble.vue?vue&type=script&setup=true&lang=js"

import "./SubBubble.vue?vue&type=style&index=0&id=512f4f8b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-512f4f8b"]])

export default __exports__